export default __webpack_public_path__ + "static/media/yingxiao.cc5cac02.png";